import React from 'react';
import styled from 'styled-components';

import { Icon } from '@ui/icons/Icon.tsx';

import { useCSSColors } from '../../../../../src/hooks/useCSSColors.ts';
import { RouteOptionsClassification } from '../constants.ts';
import { RouteTypeInfo } from './styles.ts';

export const RouteTypeMsg = styled.div`
  ${({ theme }) => theme.fontSize('14px')};
  font-weight: 500;
  margin-top: 18px;
`;

const RouteOptions = ({ routeTypes, T }) => {
  const colors = useCSSColors();
  const noAccessibleRouteInfo = (
    <RouteTypeInfo data-testid="NoAccessibleRoute">
      <Icon className="icon" width={24} height={24} name="triangle-warning" cdn fillColor={colors.widgetIconFill} />
      {T('getDirectionsFromTo:No accessible route found')}
    </RouteTypeInfo>
  );

  const defaultRouteAccessibleInfo = (
    <RouteTypeInfo data-testid="DefaultAccessibleInfo">
      <Icon className="icon" width={24} height={24} name="accessible" cdn fillColor={colors.widgetIconFill} />
      {T('getDirectionsFromTo:This route is accessible')}
    </RouteTypeInfo>
  );

  const getRouteType = () => {
    switch (routeTypes) {
      case RouteOptionsClassification.NO_ACCESSIBLE_ROUTES:
        return noAccessibleRouteInfo;
      case RouteOptionsClassification.DEFAULT_IS_ACCESSIBLE:
        return defaultRouteAccessibleInfo;
      default:
        return null;
    }
  };

  const routeTypeComponent = getRouteType();
  return routeTypeComponent ? (
    <RouteTypeMsg data-testid="RouteTypeInfo" aria-live="polite">
      {routeTypeComponent}
    </RouteTypeMsg>
  ) : null;
};

export default RouteOptions;
